export const SET_SOURCE_PAYLOAD = "SET_SOURCE_PAYLOAD";
export const SET_ACTIVE_SOURCE = "SET_ACTIVE_SOURCE";
export const HANDLE_NEED_CONFIRMATION = "HANDLE_NEED_CONFIRMATION";
export const SET_FILTERED_ONLY_COUNT = "SET_FILTERED_ONLY_COUNT";
export const HANDLE_SHOW_CONFIRMATION = "HANDLE_SHOW_CONFIRMATION";
export const RESET_TO_INITIAL_STATE = "RESET_TO_INITIAL_STATE";
